import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '../components/Layout';

const ContactPage = () => {
  return (
    <Layout>
      <Helmet>
        <title>Contact MVPsec.ai | Get Enterprise Cybersecurity Quote</title>
        <meta name="description" content="Contact MVPsec.ai for enterprise cybersecurity solutions. Get expert consultation on threat detection, penetration testing, and comprehensive security services." />
        <meta name="keywords" content="contact cybersecurity, enterprise security consultation, cybersecurity quote, security assessment" />
        <link rel="canonical" href="https://mvpsec.ai/contact" />

        <meta property="og:title" content="Contact MVPsec.ai | Enterprise Cybersecurity" />
        <meta property="og:description" content="Get in touch with cybersecurity experts for enterprise-grade security solutions and threat protection." />
        <meta property="og:url" content="https://mvpsec.ai/contact" />
      </Helmet>
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-primary-900 via-secondary-900 to-dark-950 py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-6xl font-display font-bold bg-gradient-to-r from-white via-primary-200 to-accent-300 bg-clip-text text-transparent mb-6">
            Get in Touch
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            We're here to help and answer any question you might have. We look forward to hearing from you.
          </p>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 dark:from-dark-950 dark:to-dark-900 py-16">
        <div className="container mx-auto px-4">
          <div className="flex justify-center">
            <div className="w-full max-w-lg">
              <form className="bg-white dark:bg-dark-800 p-8 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 border border-gray-100 dark:border-gray-800 hover:border-primary-200 dark:hover:border-primary-800">
                <div className="mb-6">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" htmlFor="name">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    placeholder="Your name"
                    className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-dark-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all"
                  />
                </div>
                <div className="mb-6">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" htmlFor="email">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    placeholder="Your email"
                    className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-dark-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all"
                  />
                </div>
                <div className="mb-6">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" htmlFor="message">
                    Message
                  </label>
                  <textarea
                    id="message"
                    placeholder="Your message"
                    className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-dark-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all resize-none"
                    rows="4"
                  ></textarea>
                </div>
                <div className="mt-8">
                  <button
                    type="submit"
                    className="w-full px-8 py-4 bg-gradient-to-r from-primary-600 to-accent-600 text-white font-semibold rounded-2xl shadow-2xl hover:shadow-cyber transition-all duration-300 hover:scale-105"
                  >
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ContactPage;
